import { createAsyncThunk } from '@reduxjs/toolkit';
import { checkIfTeamsChatExists } from 'services/teamsChat';

interface IProps {
  ticketId: number;
  psaId: number;
  contactId: number;
}

export const ThunkCheckIsTeamsChatExist = createAsyncThunk(
  'teamsChat/checkIsTeamsChatExist',
  async ({ ticketId, psaId, contactId }: IProps) =>
    checkIfTeamsChatExists(ticketId, psaId, contactId).then(d => d.data),
);

export default {};
